import script from "./ScoreLine.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScoreLine.vue?vue&type=script&setup=true&lang=ts"

import "./ScoreLine.vue?vue&type=style&index=0&id=49289c28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49289c28"]])

export default __exports__